<template>
  <div class="ps-tabs">
    <button
      v-for="tab in tabs"
      :key="tab.key"
      type="button"
      class="ps-tabs__item"
      :class="{ active: value === tab.key }"
      :title="tab.tip"
      @click="onSelect(tab.key)"
      v-if="!isDetailReadonly || (tab.key != 'requests' && tab.key != 'history')"
    >
      <span>{{ tab.label }}</span>
      <span
        v-if="tab.key === 'requests' && requestCount > 0"
        class="ps-tabs__num warn"
        >{{ requestCount }}</span
      >
      <span
        v-else-if="tab.key === 'history' && historyCount > 0"
        class="ps-tabs__num"
        >{{ historyCount }}</span
      >
    </button>
  </div>
</template>

<script>
import { DETAIL_TABS } from "./moduleConfig.js";

export default {
  name: "ProjectDetailTabs",
  props: {
    /** 当前 Tab：current | versions | history | requests */
    value: {
      type: String,
      default: "current",
    },
    /** 变更请求（待审核）数量 */
    requestCount: {
      type: Number,
      default: 0,
    },
    /** 变更历史（通过+驳回）数量 */
    historyCount: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    tabs() {
      return DETAIL_TABS;
    },
    /** 只读教育侧角色（教育厅/局）：详情页仅保留「现状」标签 */
    isDetailReadonly() {
      const r = this.$store.state.role;
      return r === "education-guide-role" || r === "education-role";
    },
  },
  methods: {
    onSelect(key) {
      this.$emit("input", key);
      this.$emit("change", key);
    },
  },
};
</script>

<style lang="scss" scoped>
.ps-tabs {
  display: flex;
  gap: 4px;
  padding: 0;
  font-family: "Microsoft YaHei", "微软雅黑", sans-serif;

  &__item {
    background: #e9f1fe;
    border: none;
    border-radius: 17px;
    min-width: 88px;
    height: 35px;
    padding: 0 18px;
    font-size: 18px;
    color: #2964d3;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    font-family: inherit;
    transition: background 0.15s, color 0.15s;

    &:hover {
      background: #d9e7fd;
    }

    &.active {
      background: #2964d3;
      color: #fff;
      font-weight: 400;
    }
  }

  &__num {
    background: rgba(41, 100, 211, 0.15);
    color: #2964d3;
    font-size: 12px;
    border-radius: 999px;
    padding: 1px 7px;
    line-height: 1.3;

    .active & {
      background: rgba(255, 255, 255, 0.25);
      color: #fff;
    }

    &.warn {
      background: #ef4444;
      color: #fff;
    }
  }
}
</style>
